export default {"src":"/_next/static/media/user-icon.48015375.svg","height":12,"width":10};